const loopbackHosts = new Set(['localhost', '127.0.0.1', '[::1]', '::1'])

/**
 * Parses a CLI redirect only when it points at an exact HTTP loopback host.
 * The CLI needs arbitrary local ports, but must never receive tokens at a
 * remotely controlled host.
 */
export const parseCliRedirect = (redirectTo?: string) => {
  if (!redirectTo) return undefined

  try {
    const url = new URL(redirectTo)
    if (url.protocol !== 'http:') return undefined
    if (url.username || url.password) return undefined
    if (!loopbackHosts.has(url.hostname)) return undefined
    return url
  } catch {
    return undefined
  }
}
